import { Grid, Typography } from '@mui/material';
import { ActionTypes } from '@tassat/common-definitions';
import { AddAcgNumberForm } from '@tassat/forms';
import { AccountClientGroupRecord } from '@tassat/fred-definitions';
import { ACG as ACGIcon } from '@tassat/icon';
import { FormModal } from '@tassat/modal';
import React from 'react';
import { Route } from 'react-router-dom';

import { submitAddAcgNumberForm } from 'Containers/admin/forms/helpers/addAcgNumberFormFn';
import Header from 'Containers/header';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAcgArray, getAcgArrayWithModifiedByNames } from 'Selectors/acg';
import { PageHeaderTitle } from 'SharedComponents/pageHeader';

import ACGNumberDetails from './ACGNumberDetails';
import ACGNumberGrid from './ACGNumberGrid';

import type { IAcgPageProps } from '.';

export const PAGE_TITLE = 'ACG Number';

export function ACGNumbersPage (props: IAcgPageProps) {
    const {
        classes,
        location
    } = props;
    const activeAcgs = useAppSelector((state) => getAcgArray(state, false, false));
    const acgs = useAppSelector((state) => getAcgArrayWithModifiedByNames(state, false, false));
    const [ filterModel, setFilterModel ] = React.useState<any>(location.state);
    const [ addACGNumModalOpen, setAddACGNumModalOpen ] = React.useState<boolean>(false);
    const [ formType, setFormType ] = React.useState<ActionTypes>(ActionTypes.add);
    const [ editACGNum, setEditACGNum ] = React.useState<AccountClientGroupRecord | undefined>(undefined);
    const editACGNumber = (acg) => {
        setEditACGNum(acg);
        setFormType(ActionTypes.edit);
        setAddACGNumModalOpen(true);
    };

    return (
        <Grid
            className={classes.grow}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Header />
            <Grid
                className={classes.header}
                item
                xs={12}
            >
                <PageHeaderTitle
                    form={true}
                    onClick={() => setAddACGNumModalOpen(!addACGNumModalOpen)}
                    title={PAGE_TITLE}
                />
            </Grid>
            <Grid
                container
                direction='row'
                item
                spacing={0}
                wrap='nowrap'
                xs={12}
            >
                <Grid
                    className={classes.gridContainer}
                    item
                    xs={4}
                >
                    <ACGNumberGrid
                        acg={acgs}
                        filterModel={filterModel}
                        setFilterModel={setFilterModel}
                    />
                </Grid>
                <Grid
                    className={classes.userDetailsContainer}
                    item
                    xs={8}
                >
                    <Route
                        exact
                        path='/admin/acg/:acgID'
                        render={props => (
                            <ACGNumberDetails
                                {...props}
                                editACG={editACGNumber}
                            />
                        )}
                    />
                    <Route
                        exact
                        path='/admin/acg'
                        render={props => (
                            <Grid
                                alignItems='center'
                                className={classes.noSelectedUser}
                                container
                                direction='column'
                                item
                                spacing={0}
                                wrap='nowrap'
                            >
                                <ACGIcon
                                    className={classes.acgIcon}
                                    iconColor='#A9ABAC'
                                />
                                <Typography variant='body1'>Select a ACG Number on the left to view or edit information.</Typography>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
            <FormModal
                Form={AddAcgNumberForm}
                formProps={{
                    actionType: formType,
                    editACGNum: editACGNum,
                    activeAcgs: activeAcgs,
                    submitAddAcgNumberForm: submitAddAcgNumberForm
                }}
                onClose={() => {
                    setAddACGNumModalOpen(false);
                    setFormType(ActionTypes.add);
                    setEditACGNum(undefined);
                }}
                open={addACGNumModalOpen}
                title={`${formType === ActionTypes.add ? 'New' : 'Edit'} ACG Number`}
            />
        </Grid>
    );
}